import allImgPaths from "assets/images"
import CustomCheckBox from "components/CustomCheckBox"
import HistoryTimesLab from "components/history/HistoryTimesLab";
import { cloneDeep } from "lodash"
import { endOfMonth, endOfWeek, endOfYear, format, formatDistanceToNow, startOfMonth, startOfToday, startOfWeek, startOfYear, subDays, subMonths, subYears } from "date-fns"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { getHistoryData, getHistoryFilters } from "services/event"
import { ExistingSettingMemberLoader } from "components/loaders"
import calenderIcon from "../../assets/images/callender-icon.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { optionProp } from "types";

const initFilterData: any = {
    types: [],
    blocks: [],
    members: []
}

const initSelectState: any = {
    types: false,
    blocks: false,
    members: false
}

const calculateDateRangesInTimestamps = () => {
    const today = startOfToday().getTime();
    const yesterday = subDays(startOfToday(), 1).getTime();
    const thisWeekStart = startOfWeek(startOfToday()).getTime();
    const lastWeekStart = startOfWeek(subDays(startOfWeek(startOfToday()), 1)).getTime();
    const lastWeekEnd = endOfWeek(subDays(startOfWeek(startOfToday()), 1)).getTime();
    const thisMonthStart = startOfMonth(startOfToday()).getTime();
    const lastMonthStart = startOfMonth(subMonths(startOfToday(), 1)).getTime();
    const lastMonthEnd = endOfMonth(subMonths(startOfToday(), 1)).getTime();
    const thisYearStart = startOfYear(startOfToday()).getTime();
    const lastYearStart = startOfYear(subYears(startOfToday(), 1)).getTime();
    const lastYearEnd = endOfYear(subYears(startOfToday(), 1)).getTime();

    return {
        today,
        yesterday,
        thisWeek: { start: thisWeekStart, end: subDays(startOfToday(), 2).getTime() },
        lastWeek: { start: lastWeekStart, end: lastWeekEnd },
        thisMonth: { start: thisMonthStart, end: lastWeekStart },
        lastMonth: { start: lastMonthStart, end: lastMonthEnd },
        thisYear: { start: thisYearStart, end: subMonths(startOfToday(), 1).getTime() },
        lastYear: { start: lastYearStart, end: lastYearEnd },
        older: { end: lastYearStart }
    };
};

const HistoryContainer = () => {
    const { id } = useParams();
    const [filterData, setFilterData] = useState<any>(initFilterData)
    const [mainSelection, setMainSelection] = useState<any>(initSelectState)
    const [callFilterAPI, setCallFilterAPI] = useState<boolean>(true)
    const [callHistoryAPI, setCallHistoryAPI] = useState<boolean>(false)
    // const [historyData, setHistoryData] = useState<any>([])
    const [historyData, setHistoryData] = useState<any>(null)
    const [filterLoading, setFilterLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const dateRanges = calculateDateRangesInTimestamps();
    const [currentUser, setCurrentUser] = useState<any>(null);

    const [dateRange, setDateRange] = useState<any>([null, null]);
    const [selectedValue, setSelectedValue] = useState<optionProp | null>(null);
    const [startDate, endDate]: any = dateRange;


    useEffect(() => {
        if (callFilterAPI) fetchFilters()
    }, [callFilterAPI])

    useEffect(() => {
        if (callHistoryAPI) createPayload();
    }, [callHistoryAPI]);

    useEffect(() => {
        setCurrentUser(JSON.parse(localStorage.getItem('userData') as string));
    }, [])

    const filterDataByDateRanges = (data: any[]) => {
        const filteredData: any = {
            today: [],
            yesterday: [],
            thisWeek: [],
            lastWeek: [],
            thisMonth: [],
            lastMonth: [],
            thisYear: [],
            lastYear: [],
            older: []
        };

        // Filter for today
        filteredData.today = data.filter((item: any) => new Date(item.createdAt).getTime() > dateRanges.today);
        data = data.filter((item: any) => new Date(item.createdAt).getTime() < dateRanges.today);

        // Filter for yesterday
        filteredData.yesterday = data.filter((item: any) => new Date(item.createdAt).getTime() > dateRanges.yesterday);
        data = data.filter((item: any) => new Date(item.createdAt).getTime() < dateRanges.yesterday);

        // Filter for this week
        filteredData.thisWeek = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return createdDate >= dateRanges.thisWeek.start && createdDate <= dateRanges.thisWeek.end;
        });
        data = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return !(createdDate >= dateRanges.thisWeek.start && createdDate <= dateRanges.thisWeek.end);
        });

        // Filter for last week
        filteredData.lastWeek = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return createdDate >= dateRanges.lastWeek.start && createdDate <= dateRanges.lastWeek.end;
        });
        data = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return !(createdDate >= dateRanges.lastWeek.start && createdDate <= dateRanges.lastWeek.end);
        });

        // Filter for this month
        filteredData.thisMonth = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return createdDate >= dateRanges.thisMonth.start && createdDate <= dateRanges.thisMonth.end;
        });
        data = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return !(createdDate >= dateRanges.thisMonth.start && createdDate <= dateRanges.thisMonth.end);
        });

        // Filter for last month
        filteredData.lastMonth = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return createdDate >= dateRanges.lastMonth.start && createdDate <= dateRanges.lastMonth.end;
        });
        data = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return !(createdDate >= dateRanges.lastMonth.start && createdDate <= dateRanges.lastMonth.end);
        });

        // Filter for this year
        filteredData.thisYear = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return createdDate >= dateRanges.thisYear.start && createdDate <= dateRanges.thisYear.end;
        });
        data = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return !(createdDate >= dateRanges.thisYear.start && createdDate <= dateRanges.thisYear.end);
        });

        // Filter for last year
        filteredData.lastYear = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return createdDate >= dateRanges.lastYear.start && createdDate <= dateRanges.lastYear.end;
        });
        data = data.filter((item: any) => {
            const createdDate = new Date(item.createdAt).getTime();
            return !(createdDate >= dateRanges.lastYear.start && createdDate <= dateRanges.lastYear.end);
        });

        // Filter for older
        filteredData.older = data.filter((item: any) => new Date(item.createdAt).getTime() < dateRanges.older.end);

        return filteredData;
    };

    const fetchFilters = async () => {
        setFilterLoading(true)
        const { data } = await getHistoryFilters({ eventId: id })
        setCallFilterAPI(false);

        const typesData = data?.find((dt: any) => dt.title == 'Types')?.data || [];
        const blocksData = data?.find((dt: any) => dt.title == 'Blocks')?.data || [];
        const membersData = data?.find((dt: any) => dt.title == 'Members')?.data || [];

        setFilterData({ ...filterData, types: typesData, blocks: blocksData, members: membersData })
        setFilterLoading(false)
        setCallHistoryAPI(true)
    }

    const handleTypeSelection = (payload: any) => {
        const { name, isChecked, varName } = payload
        setMainSelection({ ...mainSelection, [name]: isChecked });

        // If main checkbox is checked, mark all as checked. Not implemented for uncheck al if main checkbox is unchecked
        let selectedData = cloneDeep(filterData[varName]);
        selectedData = selectedData.map((sd: any) => ({ ...sd, selected: isChecked }))
        setFilterData({
            ...filterData,
            [varName]: selectedData
        })

        setCallHistoryAPI(true)
    }

    const handleValueSelection = (payload: any) => {
        const { index, isChecked, varName } = payload
        let selectedData = cloneDeep(filterData[varName]);

        selectedData[index]['selected'] = isChecked;
        // Update state of Data
        setFilterData({
            ...filterData,
            [varName]: selectedData
        });

        // If atleast one item is unchecked, uncheck the main checkbox as well
        if (!isChecked) {
            setMainSelection({ ...mainSelection, [varName]: isChecked });
        }

        // If all items are checked, then check the main checkbox as well
        const isAllSelected = selectedData.every((sd: any) => sd.selected === true)
        if (isAllSelected) {
            setMainSelection({ ...mainSelection, [varName]: true });
        }

        setCallHistoryAPI(true)
    }

    const clearAll = () => {
        setFilterData({
            types: filterData?.types?.map((el: any) => ({ ...el, selected: false })),
            blocks: filterData?.blocks?.map((el: any) => ({ ...el, selected: false })),
            members: filterData?.members.map((el: any) => ({ ...el, selected: false }))
        })
        setMainSelection({
            types: false, blocks: false, members: false
        })
        setCallHistoryAPI(true)
    }

    const createPayload = () => {
        const stateData = cloneDeep(filterData)
        const types = (stateData.types.filter((el: any) => el.selected) || []).map((type: any) => type.title);
        const blocks = (stateData.blocks.filter((el: any) => el.selected) || []).map((block: any) => block._id);
        const members = (stateData.members.filter((el: any) => el.selected) || []).map((member: any) => member.user_id);

        let payload: any = {
            eventId: id, types, blocks, members
        }

        if (startDate && endDate) payload = { ...payload, startDate, endDate }

        fetchHistoryData(payload)
    }

    const fetchHistoryData = async (payload: any) => {
        setHistoryData(null)
        setLoading(true);
        const { data } = await getHistoryData(payload)
        setCallHistoryAPI(false)

        const updatedData = data.map((dt: any) => {
            const userInfo = (filterData.members || []).find((ui: any) => JSON.stringify(ui.user_id) == JSON.stringify(dt?.user._id));
            dt['user'] = {
                ...dt['user'],
                profile_image: userInfo?.profile_image || null
            }

            return dt;
        })

        if (updatedData?.length) {
            const groupedData = filterDataByDateRanges(updatedData)
            console.log({ groupedData })
            setHistoryData(groupedData)
        } else {
            setHistoryData(null)
        }

        setLoading(false);
    }

    const handleUploadError = (e: any) => {
        e.target.src = allImgPaths.defaultProfile
    }

    const formatDate = (date: any) => {
        return format(date, "EEEE, MMM dd, yyyy");
    };

    const onDateRangeChanges = (dateRange: any) => {
        if (dateRange && dateRange[0] && dateRange[1]) {
            const startDate = format(dateRange[0], 'MM-dd-yyyy')
            const endDate = format(dateRange[1], 'MM-dd-yyyy');

            setCallHistoryAPI(true)
        }

        if (!dateRange?.length || (!dateRange[0] && !dateRange[1])) {
            setCallHistoryAPI(true)
        }
        setDateRange(dateRange);
    }

    return (
        <div className="px-6 py-6 w-full flex gap-x-6 items-start">
            {loading && (filterData.members.length == 0 && filterData.members.blocks == 0 && filterData.members.types == 0) && <ExistingSettingMemberLoader />}

            {/* Filters Wrapper */}
            {
                !filterLoading && (filterData.members.length > 0 || filterData.members.blocks > 0 || filterData.members.types > 0) &&
                <div className="border border-[#D0D5DD] rounded-lg py-4 px-4 bg-[#fff] w-full max-w-[332px]">
                    {/* Heading */}
                    <div className="w-full flex items-center justify-between border-b border-[#EAECF0] pb-1">
                        <h3 className="text-lg text-[#101828] font-interBold pb-0.5">Filters</h3>
                        <span className="text-[#1E0AF5] font-interSemiBold text-sm cursor-pointer hover:bg-[#e8e6fe] rounded py-0.5 px-1" onClick={clearAll}>
                            Clear All
                        </span>
                    </div>

                    {/* Filters */}
                    {<div className="">
                        <div className="">
                            <div className="mt-4 border-b border-[#F2F4F7]">
                                <CustomCheckBox
                                    name="types"
                                    label={'Types'}
                                    checked={mainSelection.types}
                                    customLabelStyle="font-interSemiBold text-base text-[#344054] pl-1.5"
                                    customStyle="mb-4"
                                    onChange={(name: string, isChecked: boolean) => handleTypeSelection({ name, isChecked, varName: 'types' })}
                                />

                                <div className="pl-6">
                                    {
                                        (filterData.types || []).map((item: any, index: number) => (
                                            <span className="checkbox-alignment mb-4 last:mb-3 block" key={index}>
                                                <CustomCheckBox
                                                    name={item.title}
                                                    label={item.title}
                                                    checked={item.selected}
                                                    customLabelStyle="font-interMedium text-sm text-[#344054] pl-1.5"
                                                    onChange={(name: string, isChecked: boolean) => handleValueSelection({ index, isChecked, varName: 'types' })}
                                                />
                                            </span>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <div className="mt-4 border-b border-[#F2F4F7]">
                                <CustomCheckBox
                                    name="blocks"
                                    label={'Blocks'}
                                    checked={mainSelection.blocks}
                                    customLabelStyle="font-interSemiBold text-base text-[#344054] pl-1.5"
                                    customStyle="mb-4"
                                    onChange={(name: string, isChecked: boolean) => handleTypeSelection({ name, isChecked, varName: 'blocks' })}
                                />

                                <div className="pl-6">
                                    {
                                        (filterData.blocks || []).map((item: any, index: number) => (
                                            <span className="checkbox-alignment mb-4 last:mb-3 block" key={index}>
                                                <CustomCheckBox
                                                    name={item.title}
                                                    label={item.title}
                                                    checked={item.selected}
                                                    customLabelStyle="font-interMedium text-sm text-[#344054] pl-1.5"
                                                    onChange={(name: string, isChecked: boolean) => handleValueSelection({ index, isChecked, varName: 'blocks' })}
                                                />
                                            </span>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>

                        {/* Members */}
                        <div className="">
                            {
                                <div className="mt-5">
                                    <CustomCheckBox
                                        name="members"
                                        label={'Members'}
                                        checked={mainSelection.members}
                                        customLabelStyle="font-interSemiBold text-base text-[#344054] pl-1.5"
                                        customStyle="mb-4"
                                        onChange={(name: string, isChecked: boolean) => handleTypeSelection({ name, isChecked, varName: 'members' })}
                                    />
                                    <div className="pl-6">
                                        {
                                            (filterData.members || []).map((item: any, index: number) => (
                                                <div className="checkbox-alignment mb-4 last:mb-0 block" key={index}>
                                                    <div className="flex items-center">
                                                        <CustomCheckBox
                                                            name={item.user_name}
                                                            label={""}
                                                            checked={item.selected}
                                                            customLabelStyle="font-interMedium text-sm text-[#344054] pl-1.5"
                                                            onChange={(name: string, isChecked: boolean) => handleValueSelection({ index, isChecked, varName: 'members' })}
                                                        />
                                                        <div className="flex gap-x-3 items-center">
                                                            <img
                                                                className="w-8 h-8 rounded-full"
                                                                src={item.profile_image || allImgPaths.defaultProfile}
                                                                alt=""
                                                                onError={(e: any) => handleUploadError(e)}
                                                            />
                                                            <div className="leading-none">
                                                                <div className="flex">
                                                                    <h4 className="text-[#344054] text-sm font-interSemiBold">
                                                                        {item.user_name}
                                                                    </h4>
                                                                    <span className="text-xs font-interMedium text-[#475467] pt-0.5">
                                                                        &nbsp;{JSON.stringify(currentUser?.id) == JSON.stringify(item.user_id) ? '(You)' : ''}
                                                                    </span>
                                                                </div>
                                                                <span className="text-xs font-interMedium text-[#475467]">
                                                                    {item.eventRole.name} {!item.is_user_active ? '(Deactivated)' : ''}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>}
                </div>
            }

            {/* Filters Content */}
            <div className="px-4 w-full">
                <div className="flex mb-10 justify-end">
                    <div className="border border-[#D0D5DD] rounded-lg flex items-center gap-x-2 py-2 px-3 bg-white hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
                        <img
                            className="w-[22px] h-[22px] flex-shrink-0 "
                            src={calenderIcon}
                            alt="star icon"
                        />
                        <div className="custom-datepicker w-full datepicker-width-adjust">
                            <DatePicker
                                selectsRange={true}
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(dates: any) => onDateRangeChanges(dates)}
                                isClearable={true}
                                placeholderText="Select dates"
                                className="custom-datepicker-input placeholder:text-[#667085] placeholder:text-sm placeholder:font-interSemiBold text-sm text-[#667085] font-interSemiBold w-full"
                            />
                        </div>
                    </div>
                </div>
                {loading && <ExistingSettingMemberLoader />}

                {/* Today */}
                {
                    historyData?.today?.length > 0 &&
                    <HistoryTimesLab
                        data={historyData.today}
                        period={'Today'}
                        showDate={true}
                        date={formatDate(new Date())}
                    />
                }
                {
                    historyData?.yesterday?.length > 0 &&
                    <HistoryTimesLab
                        data={historyData.yesterday}
                        period={'Yesterday'}
                        showDate={true}
                        date={formatDate(subDays(new Date(), 1))}
                    />
                }
                {
                    historyData?.thisWeek?.length > 0 &&
                    <HistoryTimesLab
                        data={historyData.thisWeek}
                        period={'This Week'}
                        showDate={true}
                        date={null}
                    />
                }
                {
                    historyData?.lastWeek?.length > 0 &&
                    <HistoryTimesLab
                        data={historyData.lastWeek}
                        period={'Last Week'}
                        showDate={true}
                        date={null}
                    />
                }
                {
                    historyData?.thisMonth?.length > 0 &&
                    <HistoryTimesLab
                        data={historyData.thisMonth}
                        period={'This Month'}
                        showDate={true}
                        date={null}
                    />
                }
                {
                    historyData?.lastMonth?.length > 0 &&
                    <HistoryTimesLab
                        data={historyData.lastMonth}
                        period={'Last Month'}
                        showDate={true}
                        date={null}
                    />
                }
                {
                    historyData?.thisYear?.length > 0 &&
                    <HistoryTimesLab
                        data={historyData.thisYear}
                        period={'This Year'}
                        showDate={true}
                        date={null}
                    />
                }
                {
                    historyData?.lastYear?.length > 0 &&
                    <HistoryTimesLab
                        data={historyData.lastYear}
                        period={'Last Year'}
                        showDate={true}
                        date={null}
                    />
                }
                {
                    historyData?.older?.length > 0 &&
                    <HistoryTimesLab
                        data={historyData.older}
                        period={'Older'}
                        showDate={true}
                        date={null}
                    />
                }
                {
                    // !loading && historyData.length == 0 &&
                    !loading && !historyData &&
                    <div className="pt-20">
                        <img className="mb-12 mx-auto" src={allImgPaths.historyEmptyState} alt="" />
                        <p className="font-interSemiBold text-base text-[#344054] pb-1.5 text-center">No activity found...</p>
                        <p className="text-base font-normal text-[#344054] mb-4 text-center">Looks empty in here. Let’s get this party started.</p>
                    </div>
                }



                {/* Last Week */}
                {/* <HistoryTimesLab
                    data={[]}
                    period={'Last Week'}
                    showDate={false}
                /> */}

                {/* Last Month */}
                {/* <HistoryTimesLab
                    data={[]}
                    period={'Last Month'}
                    showDate={false}
                /> */}
            </div>

        </div>
    )
}

export default HistoryContainer;